import Vue from "vue";
import Router from "vue-router";
import formSubmitSuccessRoute from "@/router/formSubmitSuccessRoute";
import formSelectRoute from "@/router/formSelectRoute";
import clientCaseRoute from "@/router/clientCaseRoute";
import homeRoute from "@/router/homeRoute";
import clientBidDetailsRoute from "@/router/clientBidDetailsRoute";
import LawyerCasesPage from '@/pages/LawyerCasesPage';
import LawyerCaseDetailsPage from '@/pages/LawyerCaseDetailsPage';
import NotFoundPage from '@/pages/NotFoundPage';
import { storage } from '@/common/storage';
import lawyerCasesRoute from '@/router/lawyerCasesRoute';
import lawyerCaseDetailsRoute from '@/router/lawyerCaseDetailsRoute';
import moment from 'moment';
import lawyerSignupRoute from "@/router/lawyerSignupRoute";
import * as user from '@/services/userService';

const authGaurd = (to, from, next) => {
  if (user.auth() || !isAuthRoute(to.name)) {
      next();
  } else {
      next('/');
  }
};

Vue.use(Router);

const authRoutes = [
  clientBidDetailsRoute,
  clientCaseRoute,
  lawyerCasesRoute,
  lawyerCaseDetailsRoute,
]

function isAuthRoute(name) {
  return authRoutes.filter(route => route.name === name).length > 0
}

const router = new Router({
  routes: [
    clientBidDetailsRoute,
    clientCaseRoute,
    formSelectRoute,
    formSubmitSuccessRoute,
    homeRoute,
    lawyerSignupRoute,
    lawyerCasesRoute,
    lawyerCaseDetailsRoute,
    { path: '/404', component: NotFoundPage },
    { path: '*', redirect: '/404' },
  ]
});

router.beforeEach(authGaurd);

export default router
